import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-[#0a0d0f] text-white overflow-x-hidden" }
const _hoisted_2 = { class: "mx-auto flex max-w-6xl items-center justify-between px-4 py-3 md:px-6" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "mx-auto grid max-w-6xl grid-cols-1 gap-8 px-4 py-8 md:grid-cols-2 md:px-6 md:py-14" }
const _hoisted_6 = { class: "flex flex-col justify-center" }
const _hoisted_7 = { class: "mt-8 flex flex-wrap gap-3" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "lead-card-wrap" }
const _hoisted_10 = { class: "lead-card" }
const _hoisted_11 = { class: "md:col-span-2" }
const _hoisted_12 = { class: "md:col-span-2 grid grid-cols-1 gap-6 md:grid-cols-2" }
const _hoisted_13 = { class: "field-reset min-w-0" }
const _hoisted_14 = { class: "field-reset min-w-0" }
const _hoisted_15 = { class: "md:col-span-2 grid grid-cols-1 gap-6 md:grid-cols-2" }
const _hoisted_16 = { class: "field-reset" }
const _hoisted_17 = { class: "field-reset" }
const _hoisted_18 = { class: "md:col-span-2" }
const _hoisted_19 = { class: "md:col-span-2" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "bg-[#050911] px-6 py-14" }
const _hoisted_22 = { class: "mx-auto max-w-6xl" }
const _hoisted_23 = { class: "mt-10 grid grid-cols-1 gap-6 md:grid-cols-3" }
const _hoisted_24 = { class: "relative h-56 md:h-60 overflow-hidden" }
const _hoisted_25 = ["src", "alt"]
const _hoisted_26 = { class: "absolute bottom-4 left-5 text-xl md:text-2xl font-semibold text-white drop-shadow-lg" }
const _hoisted_27 = { class: "px-6 pb-6 pt-5" }
const _hoisted_28 = { class: "text-sm text-white/70 leading-relaxed" }
const _hoisted_29 = { class: "mt-4 flex flex-wrap gap-2" }
const _hoisted_30 = { class: "bg-[#050911] px-6 pb-16" }
const _hoisted_31 = { class: "mx-auto max-w-6xl" }
const _hoisted_32 = { class: "mt-10 grid grid-cols-1 gap-6 md:grid-cols-3" }
const _hoisted_33 = { class: "relative h-64 overflow-hidden" }
const _hoisted_34 = ["src", "alt"]
const _hoisted_35 = { class: "absolute left-6 bottom-20 flex items-center gap-2 z-20" }
const _hoisted_36 = { class: "rounded-xl border border-emerald-400/40 bg-emerald-500/15 px-3 py-1 text-[11px] font-semibold text-emerald-300 backdrop-blur-sm shadow-md" }
const _hoisted_37 = {
  key: 0,
  class: "text-emerald-300 text-xs opacity-80"
}
const _hoisted_38 = {
  key: 1,
  class: "rounded-xl border border-emerald-400/40 bg-emerald-500/15 px-3 py-1 text-[11px] font-semibold text-emerald-300 backdrop-blur-sm shadow-md"
}
const _hoisted_39 = { class: "absolute left-6 bottom-6 text-2xl font-semibold text-white drop-shadow-xl z-20" }
const _hoisted_40 = { class: "bg-[#050911] px-6 py-16" }
const _hoisted_41 = { class: "mx-auto max-w-6xl" }
const _hoisted_42 = { class: "grid grid-cols-1 gap-5 md:grid-cols-3" }
const _hoisted_43 = { class: "mb-5 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-white/5 text-xl text-emerald-400" }
const _hoisted_44 = { class: "text-base md:text-lg font-semibold text-white mb-2" }
const _hoisted_45 = { class: "text-sm text-white/70 leading-relaxed" }
const _hoisted_46 = { class: "bg-[#0b0f11] px-6 py-12" }
const _hoisted_47 = { class: "mx-auto max-w-5xl" }
const _hoisted_48 = { class: "mt-10 space-y-4" }
const _hoisted_49 = { class: "rounded-3xl border border-white/10 bg-[#0f1317] p-6" }
const _hoisted_50 = {
  key: 0,
  class: "mt-3 text-white/70 text-sm leading-relaxed"
}
const _hoisted_51 = { class: "rounded-3xl border border-white/10 bg-[#0f1317] p-6" }
const _hoisted_52 = {
  key: 0,
  class: "mt-3 text-white/70 text-sm leading-relaxed"
}
const _hoisted_53 = { class: "rounded-3xl border border-white/10 bg-[#0f1317] p-6" }
const _hoisted_54 = {
  key: 0,
  class: "mt-3 text-white/70 text-sm leading-relaxed"
}
const _hoisted_55 = { class: "rounded-3xl border border-white/10 bg-[#0f1317] p-6" }
const _hoisted_56 = {
  key: 0,
  class: "mt-3 text-white/70 text-sm leading-relaxed"
}

import {
  reactive,
  ref,
  defineComponent,
  h,
  onMounted,
  onBeforeUnmount,
  computed,  
} from 'vue'
import { useRouter } from 'vue-router'
import LocationField from '@/components/search/LocationField.vue'
import DateField from '@/components/search/DateField.vue'
import TimeField from '@/components/search/TimeField.vue'
import { getBackendBaseUrl } from '@/utils/common'

import heroImageUrl from '@/assets/landing/airport-hero.jpg'
import vwLogo from '@/assets/logo.png'

// Vehicle & route images
import sClassImg from '@/assets/landing/uae/s-class.jpg'
import vClassImg from '@/assets/landing/uae/v-class.jpg'
import eClassImg from '@/assets/landing/uae/e-class.jpg'

import saudiImg from '@/assets/landing/uae/saudi.jpg'
import qatarImg from '@/assets/landing/uae/qatar-gcc.jpg'
import europeImg from '@/assets/landing/uae/europe-usa.jpg'



const WHATSAPP_NUMBER = '97332141440' // no +
const whatsappMessage =
  'Hi, I saw your website in google. I would like an airport transfer quote from UAE (Dubai/Abu Dhabi/Sharjah).'


export default /*@__PURE__*/_defineComponent({
  __name: 'LandingPageAirportTransferUAE',
  setup(__props) {

const heroImage = heroImageUrl

const router = useRouter()
const submitting = ref(false)
const carTypeOptions = ['Premium', 'Luxury', 'SUV', 'Van']

const faq1 = ref(false)
const faq2 = ref(false)
const faq3 = ref(false)
const faq4 = ref(false)

const form = reactive({
  name: '',
  phone: '',
  email: '',
  pickup: '',
  dropoff: '',
  datetime: '',
  notes: '',
  carType: '',
  passengers: 0,
  suitcases: 0,
})

// Whats app
const whatsappUrl = computed(
  () =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(whatsappMessage)}`
)

// Data for cards
const vehicleCards = [
  {
    name: 'Mercedes S-Class',
    image: sClassImg,
    description:
      'Luxury sedan for senior executives, VIP guests and special occasions. Unmatched comfort and prestige.',
    tags: ['3 PASSENGERS', '2 LUGGAGE', 'FIRST CLASS', 'WI-FI'],
  },
  {
    name: 'Mercedes V-Class',
    image: vClassImg,
    description:
      'Spacious van for families, groups and corporate teams with extra luggage. Business conference style seating.',
    tags: ['5 PASSENGERS', '5 LUGGAGE', 'CONFERENCE LAYOUT', 'SPACIOUS'],
  },
  {
    name: 'Mercedes E-Class',
    image: eClassImg,
    description:
      'Comfortable executive sedan for regular airport runs and business trips. The standard for corporate travel.',
    tags: ['3 PASSENGERS', '2 LUGGAGE', 'BUSINESS CLASS', 'LEATHER'],
  },
]

const routeCards = [
  {
    name: 'Saudi Arabia',
    image: saudiImg,
    tags: ['UAE', 'SAUDI ARABIA'],
  },
  {
    name: 'Qatar & GCC',
    image: qatarImg,
    tags: ['UAE', 'QATAR & GCC'],
  },
  {
    name: 'Europe & USA',
    image: europeImg,
    tags: ['UAE', 'EUROPE & USA'],
  },
]


const whyCards = [
  {
    title: 'UAE-Focused',
    copy:
      'Built specifically for travellers starting from Dubai, Abu Dhabi and Sharjah.',
    icon: '📍',
  },
  {
    title: 'Global Coverage',
    copy:
      'One point of contact for trips to Saudi, Qatar, Bahrain, Kuwait, Oman, Europe and USA.',
    icon: '🌍',
  },
  {
    title: 'Professional Chauffeurs',
    copy:
      'Trained, polite drivers with premium vehicles ensuring a smooth ride.',
    icon: '👤',
  },
  {
    title: 'Meet & Greet',
    copy:
      'Drivers welcome guests at arrivals with clear signage and luggage assistance.',
    icon: '🎉',
  },
  {
    title: 'Flight Monitoring',
    copy:
      'We track flight status and adjust pickup times automatically when needed.',
    icon: '✈️',
  },
  {
    title: '24/7 Support',
    copy:
      'Round-the-clock customer service team ready to assist you anytime.',
    icon: '🎧',
  },
]

const pickUp = reactive({
  location: { id: '', name: '', isAirport: false, coordinates: { lat: null, lng: null } },
  date: null as string | null,
  time: '' as string,
})
const dropOff = reactive({
  location: { id: '', name: '', isAirport: false, coordinates: { lat: null, lng: null } },
})

const onAddressSelected = (address: any, type: 'pickUp' | 'dropOff') => {
  const add = address ?? {
    id: '',
    name: '',
    description: '',
    coordinates: { lat: null, lng: null },
  }
  if (type === 'pickUp') {
    pickUp.location = add
    form.pickup = add?.name || add?.description || ''
  } else {
    dropOff.location = add
    form.dropoff = add?.name || add?.description || ''
  }
}
const onDateChanged = (d: string) => {
  pickUp.date = d
  form.datetime = [pickUp.date, pickUp.time].filter(Boolean).join(' ')
}
const onTimeChanged = (t: string) => {
  pickUp.time = t
  form.datetime = [pickUp.date, pickUp.time].filter(Boolean).join(' ')
}

const scrollToForm = () => {
  const els = document.querySelectorAll('form')
  if (els && els[0])
    els[0].scrollIntoView({ behavior: 'smooth', block: 'start' })
}

const submitLead = async () => {
  if (!form.name || !form.phone || !form.pickup || !form.dropoff || !form.datetime) {
    alert('Please fill all required fields.')
    return
  }
  if (form.email && !/^\S+@\S+\.\S+$/.test(form.email)) {
    alert('Please enter a valid email.')
    return
  }
  if (form.passengers < 0 || form.suitcases < 0) {
    alert('Passengers / Suitcases cannot be negative.')
    return
  }

  const API_BASE = getBackendBaseUrl()
  const payload = {
    name: form.name,
    phone: form.phone,
    email: form.email || null,
    pickup: form.pickup,
    dropoff: form.dropoff,
    datetime: form.datetime,
    notes: form.notes || null,
    source: 'uae-airport-transfer',
    car_type: form.carType || null,
    passengers: Number(form.passengers) || 0,
    suitcases: Number(form.suitcases) || 0,
    pickUp,
    dropOff,
  }

  submitting.value = true
  try {
    const res = await fetch(`${API_BASE}api/leads/airport-transfer`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    })
    if (!res.ok) {
      const msg = await res.text().catch(() => '')
      throw new Error(`Request failed (${res.status}) ${msg}`)
    }
    router.push({ name: 'ThankYou' })
  } catch (e: any) {
    alert(e?.message || 'Something went wrong while submitting your request.')
  } finally {
    submitting.value = false
  }
}

/* ---------- Google Places dropdown patch (same as old page) ---------- */
function usePatchPacDropdown() {
  let rafId: number | null = null
  let running = false
  const getFocusedInput = (): HTMLInputElement | null =>
    document.activeElement?.tagName === 'INPUT'
      ? (document.activeElement as HTMLInputElement)
      : (document.querySelector('.lead-form input:focus') as HTMLInputElement | null)

  const apply = () => {
    const pacs = document.querySelectorAll<HTMLElement>('.pac-container')
    if (!pacs.length) return
    const input =
      getFocusedInput() ||
      (document.querySelector('.lead-form input') as HTMLInputElement | null)
    if (!input) return
    const r = input.getBoundingClientRect()
    const desiredWidth = Math.max(r.width + 40, 560)
    pacs.forEach(pac => {
      pac.style.setProperty('position', 'fixed', 'important')
      pac.style.setProperty('left', `${r.left}px`, 'important')
      pac.style.setProperty('top', `${r.bottom}px`, 'important')
      pac.style.setProperty('width', `${desiredWidth}px`, 'important')
      pac.style.setProperty('minWidth', `${desiredWidth}px`, 'important')
      pac.style.setProperty('maxWidth', `${desiredWidth}px`, 'important')
      pac.style.setProperty('maxHeight', '480px', 'important')
      pac.style.setProperty('overflowY', 'auto', 'important')
      pac.style.setProperty('overflowX', 'hidden', 'important')
      pac.style.setProperty('zIndex', '99999', 'important')
      pac.style.setProperty('borderRadius', '12px', 'important')
      pac.style.setProperty('border', '1px solid rgba(255,255,255,.18)', 'important')
      pac.style.setProperty('background', 'rgba(15,19,23,.98)', 'important')
      pac.style.setProperty('boxShadow', '0 12px 40px rgba(0,0,0,.5)', 'important')
      pac.style.setProperty('padding', '4px 0', 'important')
    })
  }
  const loop = () => {
    apply()
    if (running) rafId = requestAnimationFrame(loop)
  }
  const start = () => {
    if (!running) {
      running = true
      loop()
    }
  }
  const stop = () => {
    running = false
    if (rafId) cancelAnimationFrame(rafId)
    rafId = null
  }
  const onFocusIn = () => setTimeout(() => { apply(); start() }, 0)
  const onFocusOut = () => setTimeout(stop, 150)
  const onResize = () => apply()
  const onScroll = () => apply()

  onMounted(() => {
    document.addEventListener('focusin', onFocusIn, true)
    document.addEventListener('focusout', onFocusOut, true)
    window.addEventListener('resize', onResize)
    window.addEventListener('scroll', onScroll, true)
  })
  onBeforeUnmount(() => {
    document.removeEventListener('focusin', onFocusIn, true)
    document.removeEventListener('focusout', onFocusOut, true)
    window.removeEventListener('resize', onResize)
    window.removeEventListener('scroll', onScroll, true)
    stop()
  })
}
usePatchPacDropdown()

/* ---------- Reusable mini components (same as old page) ---------- */
const Badge = defineComponent({
  name: 'Badge',
  props: { icon: String },
  setup(props, { slots }) {
    const iconMap: Record<string, string> = {
      lifebuoy: '🛟',
      smile: '🙂',
      plane: '✈️',
    }
    return () =>
      h(
        'span',
        {
          class:
            'inline-flex items-center gap-2 rounded-full bg-white/5 px-3 py-1 text-xs ring-1 ring-white/10',
        },
        [h('span', { class: 'opacity-80' }, iconMap[props.icon || ''] || '•'), slots.default?.()],
      )
  },
})

const TextField = defineComponent({
  name: 'TextField',
  props: {
    label: String,
    modelValue: [String, Number],
    placeholder: String,
    type: { type: String, default: 'text' },
    min: [String, Number],
  },
  emits: ['update:modelValue'],
  setup(props, { emit, attrs }) {
    const onInput = (e: any) => emit('update:modelValue', e.target.value)
    return () =>
      h('label', { class: 'block', ...attrs }, [
        h('div', { class: 'mb-1 text-[11px] text-white/70' }, props.label),
        h('input', {
          class:
            'w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm outline-none placeholder:text-white/30 focus:border-white/30',
          value: props.modelValue,
          placeholder: props.placeholder,
          onInput,
          type: props.type,
          min: props.min,
        }),
      ])
  },
})

const NumberField = defineComponent({
  name: 'NumberField',
  props: {
    label: String,
    modelValue: [String, Number],
    min: { type: [String, Number], default: 0 },
  },
  emits: ['update:modelValue'],
  setup(props, { emit, attrs }) {
    const onInput = (e: any) =>
      emit('update:modelValue', e.target.value === '' ? '' : Number(e.target.value))
    return () =>
      h('label', { class: 'block', ...attrs }, [
        h('div', { class: 'mb-1 text-[11px] text-white/70' }, props.label),
        h('input', {
          class:
            'w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm outline-none placeholder:text-white/30 focus:border-white/30',
          value: props.modelValue,
          type: 'number',
          min: props.min,
          onInput,
        }),
      ])
  },
})

const SelectField = defineComponent({
  name: 'SelectField',
  props: {
    label: String,
    modelValue: String,
    options: Array as () => string[],
    placeholder: String,
  },
  emits: ['update:modelValue'],
  setup(props, { emit, attrs }) {
    const onChange = (e: any) => emit('update:modelValue', e.target.value)
    return () =>
      h('label', { class: 'block', ...attrs }, [
        h('div', { class: 'mb-1 text-[11px] text-white/70' }, props.label),
        h(
          'select',
          {
            class:
              'w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm outline-none focus:border-white/30',
            value: props.modelValue ?? '',
            onChange,
          },
          [
            h('option', { value: '' }, props.placeholder || 'Select…'),
            ...(props.options || []).map(o => h('option', { value: o }, o)),
          ],
        ),
      ])
  },
})

const TextArea = defineComponent({
  name: 'TextArea',
  props: { label: String, modelValue: String, placeholder: String },
  emits: ['update:modelValue'],
  setup(props, { emit, attrs }) {
    const onInput = (e: any) => emit('update:modelValue', e.target.value)
    return () =>
      h('label', { class: 'block', ...attrs }, [
        h('div', { class: 'mb-1 text-[11px] text-white/70' }, props.label),
        h('textarea', {
          class:
            'min-h-[90px] w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm outline-none placeholder:text-white/30 focus:border-white/30',
          value: props.modelValue,
          placeholder: props.placeholder,
          onInput,
        }),
      ])
  },
})

const FeatureCard = defineComponent({
  name: 'FeatureCard',
  props: { title: String, copy: String },
  setup(props) {
    return () =>
      h('div', { class: 'rounded-2xl border border-white/10 bg-[#0f1317] p-5' }, [
        h('div', { class: 'text-[13px] font-semibold' }, props.title),
        h('p', { class: 'mt-2 text-sm text-white/70' }, props.copy),
      ])
  },
})

const Testimonial = defineComponent({
  name: 'Testimonial',
  props: { text: String, who: String },
  setup(props) {
    return () =>
      h('div', { class: 'rounded-2xl border border-white/10 bg-[#0f1317] p-5' }, [
        h('div', { class: 'mb-2 text-emerald-400' }, '★★★★★'),
        h('p', { class: 'text-sm text-white/85' }, `“${props.text}”`),
        h('div', { class: 'mt-3 text-xs text-white/50' }, props.who),
      ])
  },
})

const FAQ = defineComponent({
  name: 'FAQ',
  props: { q: String, a: String },
  setup(props) {
    const open = ref(false)
    const toggle = () => (open.value = !open.value)
    return () =>
      h('div', { class: 'overflow-hidden rounded-2xl border border-white/10 bg-[#0f1317]' }, [
        h(
          'button',
          {
            class:
              'flex w-full items-center justify-between px-4 py-4 text-left text-sm font-semibold',
            onClick: toggle,
          },
          [h('span', props.q), h('span', { class: (open.value ? 'rotate-90 ' : '') + 'transition' }, '▸')],
        ),
        open.value &&
          h('div', { class: 'px-4 pb-4 text-sm text-white/70' }, props.a),
      ])
  },
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", {
      class: "relative",
      style: _normalizeStyle({
    backgroundImage: `linear-gradient(rgba(10,13,15,.78), rgba(10,13,15,.88)), url(${_unref(heroImage)})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _unref(vwLogo),
            alt: "Vehitra World",
            class: "h-12 w-auto object-contain"
          }, null, 8, _hoisted_4)
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-[11px] opacity-80" }, " 24/7 Support · WhatsApp: +973 3214 1440 ", -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[14] || (_cache[14] = _createStaticVNode("<span class=\"mb-4 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-[12px] font-semibold text-emerald-300 ring-1 ring-white/15\" data-v-64632896> ● UAE Chauffeur &amp; Airport Transfer </span><h1 class=\"leading-tight font-extrabold text-white\" data-v-64632896><span class=\"block text-4xl md:text-5xl\" data-v-64632896> Premium Global </span><span class=\"block text-4xl md:text-5xl\" data-v-64632896> Chauffeur &amp; Airport Transfers </span><span class=\"block text-4xl md:text-5xl text-emerald-300\" data-v-64632896> for UAE Travelers </span></h1><p class=\"mt-6 max-w-xl text-sm md:text-base text-white/80\" data-v-64632896> Serving travellers from Dubai, Abu Dhabi and Sharjah. </p><p class=\"mt-3 max-w-xl text-sm md:text-base text-white/80\" data-v-64632896> We provide reliable airport pickups and chauffeur services for your clients and guests. Professional drivers, clean vehicles, flight monitoring and clear pricing for every trip. </p><div class=\"mt-6 grid grid-cols-1 md:grid-cols-2 gap-3 text-white/80 text-sm\" data-v-64632896><div class=\"flex items-center gap-2\" data-v-64632896><span class=\"text-emerald-400 text-lg\" data-v-64632896>✓</span> 24/7 booking &amp; support </div><div class=\"flex items-center gap-2\" data-v-64632896><span class=\"text-emerald-400 text-lg\" data-v-64632896>✓</span> Meet &amp; greet at airports </div><div class=\"flex items-center gap-2\" data-v-64632896><span class=\"text-emerald-400 text-lg\" data-v-64632896>✓</span> Flight delay monitoring </div><div class=\"flex items-center gap-2\" data-v-64632896><span class=\"text-emerald-400 text-lg\" data-v-64632896>✓</span> Confirmed fixed pricing </div></div>", 5)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              onClick: scrollToForm,
              class: "inline-flex items-center justify-center rounded-full bg-emerald-500 px-6 py-3 text-sm font-semibold text-[#050708] transition hover:bg-emerald-400"
            }, " Get Instant Quote "),
            _createElementVNode("a", {
              href: whatsappUrl.value,
              target: "_blank",
              class: "inline-flex items-center justify-center rounded-full border border-white/20 px-5 py-3 text-sm font-semibold text-white/90 hover:bg-white/5"
            }, " WhatsApp Our Team ", 8, _hoisted_8)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "text-[20px] font-semibold" }, "Get a Quote from UAE", -1)),
            _cache[17] || (_cache[17] = _createElementVNode("p", { class: "mt-1 text-[12px] text-white/70" }, " Share your trip details and we’ll call or WhatsApp you to confirm. ", -1)),
            _createElementVNode("form", {
              onSubmit: _withModifiers(submitLead, ["prevent"]),
              class: "lead-form mt-5 grid grid-cols-1 gap-6 md:grid-cols-2"
            }, [
              _createVNode(_unref(TextField), {
                label: "Full Name*",
                placeholder: "e.g. John Doe",
                modelValue: form.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(TextField), {
                label: "Mobile / WhatsApp*",
                placeholder: "+971 5X XXX XXXX",
                modelValue: form.phone,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.phone) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_unref(TextField), {
                  label: "Email",
                  placeholder: "name@company.com",
                  modelValue: form.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.email) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(LocationField, {
                    class: "field-reset af-loc",
                    layout: 'simple',
                    drive: 'distance',
                    hasError: false,
                    data: pickUp,
                    type: "pickUp",
                    label: "Pickup from (City in UAE)*",
                    onAddressSelected: _cache[3] || (_cache[3] = addr => onAddressSelected(addr, 'pickUp'))
                  }, null, 8, ["data"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(LocationField, {
                    class: "field-reset af-loc",
                    layout: 'simple',
                    drive: 'distance',
                    hasError: false,
                    data: dropOff,
                    type: "dropOff",
                    label: "Destination (Country & City)*",
                    onAddressSelected: _cache[4] || (_cache[4] = addr => onAddressSelected(addr, 'dropOff'))
                  }, null, 8, ["data"])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(DateField, {
                    class: "field-reset af-dt",
                    layout: 'simple',
                    hasError: false,
                    data: pickUp.date,
                    onDateChanged: onDateChanged
                  }, null, 8, ["data"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(TimeField, {
                    class: "field-reset af-dt",
                    layout: 'simple',
                    hasError: false,
                    data: pickUp.time,
                    onTimeChanged: onTimeChanged
                  }, null, 8, ["data"])
                ])
              ]),
              _createVNode(_unref(SelectField), {
                class: "md:col-span-2 md:max-w-none",
                label: "Preferred car type",
                modelValue: form.carType,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.carType) = $event)),
                options: carTypeOptions,
                placeholder: "Choose car type (optional)"
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(NumberField), {
                label: "Passengers",
                modelValue: form.passengers,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.passengers) = $event)),
                modelModifiers: { number: true },
                min: "0"
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(NumberField), {
                label: "Suitcases",
                modelValue: form.suitcases,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.suitcases) = $event)),
                modelModifiers: { number: true },
                min: "0"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_unref(TextArea), {
                  label: "Additional notes (optional)",
                  placeholder: "Flight number, child seats, special requests...",
                  modelValue: form.notes,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.notes) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  type: "submit",
                  disabled: submitting.value,
                  class: "btn-primary"
                }, _toDisplayString(submitting.value ? 'Submitting…' : 'Get Confirmed Quote'), 9, _hoisted_20),
                _cache[15] || (_cache[15] = _createElementVNode("p", { class: "mt-2 text-center text-[11px] text-white/60" }, " By submitting, you agree to be contacted about your booking request. ", -1))
              ])
            ], 32)
          ])
        ])
      ])
    ], 4),
    _createElementVNode("section", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text-center" }, [
          _createElementVNode("h2", { class: "text-3xl md:text-4xl font-extrabold text-white" }, " Choose Your Vehicle "),
          _createElementVNode("p", { class: "mt-3 text-sm md:text-base text-white/70" }, " Select the ideal vehicle class for your clients and guests. ")
        ], -1)),
        _createElementVNode("div", _hoisted_23, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(vehicleCards, (car) => {
            return _createElementVNode("article", {
              key: car.name,
              class: "overflow-hidden rounded-3xl bg-[#070c14] border border-white/8 shadow-[0_24px_60px_rgba(0,0,0,.6)]"
            }, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("img", {
                  src: car.image,
                  alt: car.name,
                  class: "h-full w-full object-cover"
                }, null, 8, _hoisted_25),
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" }, null, -1)),
                _createElementVNode("h3", _hoisted_26, _toDisplayString(car.name), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("p", _hoisted_28, _toDisplayString(car.description), 1),
                _createElementVNode("div", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(car.tags, (tag) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: tag,
                      class: "rounded-full border border-white/10 bg-white/5 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-white/70"
                    }, _toDisplayString(tag), 1))
                  }), 128))
                ])
              ])
            ])
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-left" }, [
          _createElementVNode("h2", { class: "text-3xl md:text-4xl font-extrabold text-white" }, " Popular International Trips from UAE "),
          _createElementVNode("p", { class: "mt-3 text-sm md:text-base text-white/70" }, " Our team regularly supports these routes from Dubai, Abu Dhabi and Sharjah. ")
        ], -1)),
        _createElementVNode("div", _hoisted_32, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(routeCards, (route) => {
            return _createElementVNode("article", {
              key: route.name,
              class: "overflow-hidden rounded-3xl bg-[#070c14] border border-white/8 shadow-[0_24px_60px_rgba(0,0,0,.6)]"
            }, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("img", {
                  src: route.image,
                  alt: route.name,
                  class: "h-full w-full object-cover"
                }, null, 8, _hoisted_34),
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" }, null, -1)),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("span", _hoisted_36, _toDisplayString(route.tags[0]), 1),
                  (route.tags.length === 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, " → "))
                    : _createCommentVNode("", true),
                  (route.tags.length === 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(route.tags[1]), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("h3", _hoisted_39, _toDisplayString(route.name), 1)
              ])
            ])
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "text-center mb-10" }, [
          _createElementVNode("h2", { class: "text-3xl md:text-4xl font-extrabold text-white" }, " Why Corporates Choose Us "),
          _createElementVNode("p", { class: "mt-3 text-sm md:text-base text-white/70" }, " Trusted by leading travel agencies and multinational companies in the UAE. ")
        ], -1)),
        _createElementVNode("div", _hoisted_42, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(whyCards, (item) => {
            return _createElementVNode("div", {
              key: item.title,
              class: "rounded-3xl bg-[#070c14] border border-white/8 px-7 py-7 flex flex-col"
            }, [
              _createElementVNode("div", _hoisted_43, _toDisplayString(item.icon), 1),
              _createElementVNode("h3", _hoisted_44, _toDisplayString(item.title), 1),
              _createElementVNode("p", _hoisted_45, _toDisplayString(item.copy), 1)
            ])
          }), 64))
        ])
      ])
    ]),
    _cache[32] || (_cache[32] = _createStaticVNode("<section class=\"bg-[#0e1114] px-6 pb-10 pt-14\" data-v-64632896><div class=\"mx-auto max-w-6xl\" data-v-64632896><div class=\"mb-10 text-center\" data-v-64632896><h2 class=\"text-3xl md:text-4xl font-extrabold text-white\" data-v-64632896> What Our Clients Say </h2><p class=\"mt-3 text-sm md:text-base text-white/70\" data-v-64632896> Trusted by leading travel agencies and multinational companies across the UAE. </p></div><div class=\"grid grid-cols-1 md:grid-cols-3 gap-6\" data-v-64632896><div class=\"rounded-3xl border border-white/10 bg-[#0f1317] p-6 relative\" data-v-64632896><p class=\"text-white/85 text-sm leading-relaxed\" data-v-64632896> “Very smooth coordination for our clients travelling from Dubai to Riyadh and Jeddah. Reliable cars and drivers.” </p><div class=\"mt-5 font-semibold text-white\" data-v-64632896>Travel Agency</div><div class=\"text-xs text-white/50\" data-v-64632896>Dubai</div></div><div class=\"rounded-3xl border border-white/10 bg-[#0f1317] p-6\" data-v-64632896><p class=\"text-white/85 text-sm leading-relaxed\" data-v-64632896> “We use them for executive trips to Europe and the USA. Our team feels safe and taken care of.” </p><div class=\"mt-5 font-semibold text-white\" data-v-64632896>Corporate Travel Manager</div><div class=\"text-xs text-white/50\" data-v-64632896>Abu Dhabi</div></div><div class=\"rounded-3xl border border-white/10 bg-[#0f1317] p-6\" data-v-64632896><p class=\"text-white/85 text-sm leading-relaxed\" data-v-64632896> “Good communication on WhatsApp, especially when flights are delayed.” </p><div class=\"mt-5 font-semibold text-white\" data-v-64632896>Group Travel Planner</div><div class=\"text-xs text-white/50\" data-v-64632896>Sharjah</div></div></div></div></section>", 1)),
    _createElementVNode("section", _hoisted_46, [
      _createElementVNode("div", _hoisted_47, [
        _cache[27] || (_cache[27] = _createElementVNode("h2", { class: "text-center text-3xl md:text-4xl font-extrabold text-white" }, " Frequently Asked Questions ", -1)),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("button", {
              class: "w-full flex justify-between items-center text-left",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (faq1.value = !faq1.value))
            }, [
              _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-emerald-400 font-semibold text-[15px]" }, " Do you support all Emirates? ", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["text-emerald-400 transition", faq1.value ? 'rotate-180' : ''])
              }, "▲", 2)
            ]),
            (faq1.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, " Yes, we mainly work with clients in Dubai, Abu Dhabi and Sharjah, and can support other Emirates (Ras Al Khaimah, Fujairah) on request. "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("button", {
              class: "w-full flex justify-between items-center text-left",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (faq2.value = !faq2.value))
            }, [
              _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-emerald-400 font-semibold text-[15px]" }, " Can you handle big groups for events in Saudi? ", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["text-emerald-400 transition", faq2.value ? 'rotate-180' : ''])
              }, "▲", 2)
            ]),
            (faq2.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, " Yes. We can arrange multiple vehicles or premium minibuses for conferences, exhibitions, and delegations ensuring everyone arrives together. "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("button", {
              class: "w-full flex justify-between items-center text-left",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (faq3.value = !faq3.value))
            }, [
              _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-emerald-400 font-semibold text-[15px]" }, " How do we get the final price? ", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["text-emerald-400 transition", faq3.value ? 'rotate-180' : ''])
              }, "▲", 2)
            ]),
            (faq3.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, " After you submit the form, our team will calculate the best option based on your route and vehicle choice, then send you a clear quote by email or WhatsApp. "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("button", {
              class: "w-full flex justify-between items-center text-left",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (faq4.value = !faq4.value))
            }, [
              _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text-emerald-400 font-semibold text-[15px]" }, " Can travel agencies and corporates have long-term agreements? ", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["text-emerald-400 transition", faq4.value ? 'rotate-180' : ''])
              }, "▲", 2)
            ]),
            (faq4.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, " Yes, we can discuss regular cooperation, monthly billing, and tailored pricing for frequent bookings originating from the UAE. "))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", { class: "bg-[#01060d] px-6 py-20 relative overflow-hidden" }, [
      _cache[31] || (_cache[31] = _createElementVNode("div", { class: "pointer-events-none absolute inset-0 flex items-center justify-center" }, [
        _createElementVNode("div", { class: "h-[600px] w-[600px] rounded-full bg-emerald-600/10 blur-[160px]" })
      ], -1)),
      _createElementVNode("div", { class: "mx-auto max-w-4xl text-center relative z-10" }, [
        _cache[29] || (_cache[29] = _createElementVNode("h2", { class: "text-3xl md:text-4xl font-extrabold text-white leading-tight" }, [
          _createTextVNode(" Ready to plan your next trip from "),
          _createElementVNode("span", { class: "text-emerald-400" }, "UAE?")
        ], -1)),
        _cache[30] || (_cache[30] = _createElementVNode("p", { class: "mx-auto mt-4 max-w-2xl text-white/70 text-sm md:text-base leading-relaxed" }, " Tell us your route from Dubai, Abu Dhabi or Sharjah, and we’ll take care of your ground transportation in Saudi, GCC, Europe or the USA. ", -1)),
        _createElementVNode("button", {
          onClick: scrollToForm,
          class: "mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-emerald-500 px-8 py-4 text-base font-semibold text-[#020617] shadow-lg shadow-emerald-500/30 hover:bg-emerald-400 transition"
        }, _cache[28] || (_cache[28] = [
          _createTextVNode(" Get Instant Quote "),
          _createElementVNode("span", { class: "text-xl" }, "↗", -1)
        ]))
      ])
    ]),
    _cache[33] || (_cache[33] = _createElementVNode("footer", { class: "bg-[#000409] px-6 py-8 border-t border-white/10" }, [
      _createElementVNode("div", { class: "mx-auto max-w-6xl text-center text-[12px] text-white/40" }, [
        _createTextVNode(" © 2025 Vehitra World • All Rights Reserved "),
        _createElementVNode("br"),
        _createElementVNode("span", { class: "text-white/30" }, "Privacy Policy · Terms · Contact")
      ])
    ], -1))
  ]))
}
}

})